var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcWcagAnimationPlay = function SvgIcWcagAnimationPlay(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "ic_animacja_play")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_animacja_pause",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,0 C15.5228475,0 20,4.4771525 20,10 C20,15.5228475 15.5228475,20 10,20 C4.4771525,20 0,15.5228475 0,10 C0,4.4771525 4.4771525,0 10,0 Z M10,2.2 C5.69217895,2.2 2.2,5.69217895 2.2,10 C2.2,14.307821 5.69217895,17.8 10,17.8 C14.307821,17.8 17.8,14.307821 17.8,10 C17.8,5.69217895 14.307821,2.2 10,2.2 Z M6.5,6.3 C6.5,5.44677701 7.42924412,4.91839517 8.16248195,5.35468838 L8.16248195,5.35468838 L14.3807313,9.05468838 C15.097422,9.48113569 15.097422,10.5188643 14.3807313,10.9453116 L14.3807313,10.9453116 L8.16248195,14.6453116 C7.42924412,15.0816048 6.5,14.553223 6.5,13.7 L6.5,13.7 Z M8.699,8.234 L8.699,11.765 L11.666,10 L8.699,8.234 Z",
    id: "ic_animacja_play"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcWcagAnimationPlay, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_wcag_animation_play.55eecbe0.svg";
export { ForwardRef as ReactComponent };